import "react-app-polyfill/ie9";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "mobx-react";
import { Router } from "react-router";
import App from "./components/App/App";
import rootStore from "./stores/RootStore";
import registerServiceWorker from "./registerServiceWorker";
import history from "./history";
import TagManager from "react-gtm-module";
import config from "../src/config/config";
// import  ' bootstrap/dist/css/bootstrap.css'

const tagManagerArgs = {
  gtmId: config.gtmId,
};

TagManager.initialize(tagManagerArgs);

ReactDOM.render(
  <Provider
    rootStore={rootStore}
    loginStore={rootStore.loginStore}
    getStartedStore={rootStore.getStartedStore}
    profileStore={rootStore.profileStore}
    sharedStore={rootStore.sharedStore}
  >
    <Router history={history}>
      <App />
    </Router>
  </Provider>,
  document.getElementById("root")
);
registerServiceWorker();

// ReactDOM.render(React.version, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js